import Vue from "vue";
import VueResource from 'vue-resource';

import {
  API_ROOT,
  API_ROOT_V2,
  API_ROOT_V3,
  API_ACTIVITY_ROOT,
  API_ACTIVITY_ROOT_V2,
  activity,
  studyManagement,
  languages,
  questions,
  tags,
  therapeuticareas,
  types,
  activities,
  pagination,
  views,
  config,
  createdby,
  pin,
  unpin,
  arrange,
  uploadTemplate,
  image,
  video,
  templateImage,
  status,
  group,
  exportTag,
  study,
  versions,
  verify,
  edc,
  remove,
  moveActivityToThreadLibrary,
  onboardedclients,
  migration
} from "./urls";

Vue.use(VueResource);
// TAGS
const activityTagsResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${tags}`, {}, { update: { method: "POST" } });

const updateActivityTagsResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${tags}/{tagId}`, {}, { update: { method: "PUT" } });

const groupResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${group}`, {}, { update: { method: "POST" } });

const updateGroupResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${group}/{groupId}`, {}, { update: { method: "PUT" } });

// THERAPEUTIC AREAS
const getTherapeuticAreasResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${therapeuticareas}`);

const getCreatedBysResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${createdby}`);

// ACTIVITY TYPES
const getActivityTypesResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${types}`);

// ACTIVITIES LIST
const getNotificationActivity = Vue.resource(`${API_ROOT_V2}${edc}/${activities}`);

const getNotificationActivityV3 = Vue.resource(`${API_ROOT_V3}${edc}/${activities}`);

const getActivitiesListResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/${pagination}`, {}, { update: { method: "PUT" } });

const getActivitiesThreadLibraryResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/${moveActivityToThreadLibrary}`, {}, { update: { method: "PUT" } });

const activityViewsResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${views}`, {}, { update: { method: "POST" } });

const updateActivityViewsResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${views}`, {}, { update: { method: "PUT" } });

// FORM CONFIG
const getActivityFormConfigResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${config}`);

// CREATE ACTIVITY
const createActivtyResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}`, {}, { update: { method: "POST" } });

const verifyActivityResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/${verify}`, {}, { update: { method: "POST" } });

const getActivityResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}`, {}, { update: { method: "PUT" } });

const getActivityVersionResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${versions}`, {}, { update: { method: "PUT" } });

const getActivityStudyResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${study}`, {}, { update: { method: "PUT" } });

// languages
const getClientLanguages = Vue.resource(`${API_ROOT}${studyManagement}${languages}`, {}, { update: { method: "GET" } });

const pinActivityResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${pin}`, {}, { update: { method: "PUT" } });

const unPinActivityResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${unpin}`, {}, { update: { method: "PUT" } });

const questionsResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${questions}{/questionId}`, {}, { update: { method: "PUT" } });

const deleteStepsResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${remove}/${questions}`, {}, { update: { method: "PUT" } });

const activityResource = Vue.resource(
  `${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${status}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const exportResource = Vue.resource(
  `${API_ACTIVITY_ROOT}${activity}/${activities}/${exportTag}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const templateImageUpload = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${uploadTemplate}`, {}, { update: { method: "PUT" } });

const templateImageUploadResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${templateImage}`, {}, { update: { method: "PUT" } });

const imageUploadResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${image}`, {}, { update: { method: "PUT" } });

const videoUploadResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${video}`, {}, { update: { method: "PUT" } });

const imageQuestionResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${image}`, {}, { update: { method: "PUT" } });

const questionsScreenOrder = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${questions}/${arrange}`, {}, { update: { method: "PUT" } });

// CREATE ACTIVITY USING JSON FILE UPLOAD
const createActivtyJsonFile = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/importJSON`, {}, { update: { method: "POST" } });

const getActivtyThreadInstances = Vue.resource(`${API_ROOT}${studyManagement}${onboardedclients}`, {}, { update: { method: "GET" } });

const createActivityMigration = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/{activityId}/${migration}`, {}, { update: { method: "POST" } });

const templateImageUploadResourceV2 = Vue.resource(`${API_ACTIVITY_ROOT_V2}${activity}/${activities}/{activityId}/${templateImage}`, {}, { update: { method: "PUT" } });

const imageUploadResourceV2 = Vue.resource(`${API_ACTIVITY_ROOT_V2}${activity}/${activities}/{activityId}/${image}`, {}, { update: { method: "PUT" } });

const videoUploadResourceV1 = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/${video}`, {}, { update: { method: "PUT" } });

const uploadLocalVideoResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/getVideoConversionStatus?videoId={videoId}`, {}, { update: { method: "GET" } });

const convertVideoResource = Vue.resource(`${API_ACTIVITY_ROOT}${activity}/${activities}/{activityId}/video/convert`, {}, { update: { method: "PUT" } });

// TAGS
export function createActivtyTags(data) {
  return activityTagsResource.save({}, data);
}

export function getActivityTags(queryParams) {
  return activityTagsResource.get({ ...queryParams });
}

export function modifyActivityTag(tagId, data) {
  return updateActivityTagsResource.update({ tagId }, data);
}

export function deleteActivityTag(tagId) {
  return updateActivityTagsResource.delete({ tagId });
}

//groups
export function createGroups(data) {
  return groupResource.save({}, data);
}

export function getGroups(queryParams) {
  return groupResource.get({ ...queryParams });
}

export function modifyGroup(groupId, data) {
  return updateGroupResource.update({ groupId }, data);
}

export function deleteGroup(groupId) {
  return updateGroupResource.delete({ groupId });
}

// THERAPEUTIC AREAS

export function getTherapeuticAreas() {
  return getTherapeuticAreasResource.get();
}

export function getCreatedBys() {
  return getCreatedBysResource.get();
}

// ACTIVITY TYPES
export function getActivityTypes() {
  return getActivityTypesResource.get();
}

// ACTIVITY LIBRARY
export function getNotificationActivityList(queryParams) {
  return getNotificationActivity.get({ ...queryParams });
}

export function getNotificationActivityV3List(queryParams) {
  return getNotificationActivityV3.get({ ...queryParams });
}

export function getActivitiesList(filter, queryParams) {
  return getActivitiesListResource.get({ filter, ...queryParams });
}

export function getActivitiesThreadLibrary(data) {
  return getActivitiesThreadLibraryResource.update({}, data);
}

export function getActivityViews() {
  return activityViewsResource.get();
}

export function postActivityViews(data) {
  return activityViewsResource.save({}, data);
}

export function modifyActivityViews(data) {
  return updateActivityViewsResource.update({}, data);
}

// ACTIVITY CONFIGURATOR
export function getActivityFormConfig() {
  return getActivityFormConfigResource.get();
}

//CREATE ACTIVITY
export function createActivity(data) {
  return createActivtyResource.save({}, data);
}

export function verifyActivity(data) {
  return verifyActivityResource.save({}, data);
}

export function updateActivity(activityId, data) {
  return getActivityResource.update({ activityId }, data);
}

export function updateActivityStudyCount(activityId, revisionId, data) {
  return getActivityStudyResource.update({ activityId, revisionId }, data);
}

export function deleteActivity(activityId) {
  return getActivityResource.delete({ activityId });
}

export function getActivityDetails(activityId, revisionId) {
  return getActivityResource.get({ activityId, revisionId }, {});
}

export function getActivityVersions(activityId, queryParams) {
  return getActivityVersionResource.get({ activityId, ...queryParams }, {});
}

// languages
export function getSupportedClientLanguages() {
  return getClientLanguages.get();
}

export function pinActivity(activityId, revisionId) {
  return pinActivityResource.update({ activityId, revisionId }, {});
}

export function unpinActivity(activityId, revisionId) {
  return unPinActivityResource.update({ activityId, revisionId }, {});
}

export function deleteActivityQuestionFact(activityId, questionId) {
  return questionsResource.delete({ activityId, questionId });
}

export function deleteActivitySteps(activityId, data) {
  return deleteStepsResource.update({ activityId }, data);
}

export function updateActivityQuestionOrderFact(activityId, data) {
  return questionsScreenOrder.update({ activityId }, data);
}

export function addActivityQuestionFact(activityId, data) {
  return questionsResource.save({ activityId }, data);
}

export function updateActivityQuestionFact(activityId, questionId, question) {
  return questionsResource.update({ activityId, questionId }, question);
}

export function uploadActivityTemplateImageIcon(activityId, data) {
  return templateImageUpload.save({ activityId }, data);
}

export function deleteActivityOptionFact(activityId, data) {
  return imageUploadResource.delete({ activityId }, data);
}

export function imageActivityQuestionFact(activityId, data) {
  return imageQuestionResource.save({ activityId }, data);
}

export function imageActivityUploadFact(activityId, data, isInstructionTemplate) {
  if (isInstructionTemplate) {
    return templateImageUploadResource.save({ activityId }, data);
  }
  return imageUploadResource.save({ activityId }, data);
}

export function videoActivityUploadFact(activityId, data) {
  return videoUploadResource.save({ activityId }, data);
}

export function updateActivityStatus(activityId, revisionId, status, data, queryParams) {
  return activityResource.update({ activityId, revisionId, status, ...queryParams }, data);
}

export function getOrganizations() {
  return groupResource.get();
}

export function exportActivity(filter, val) {
  return exportResource.save({ filter, val }, {});
}

//create Activity using json file upload
export function uploadActivityJsonFile(fileData) {
  return createActivtyJsonFile.save({}, fileData);
}

export function getThreadInstances() {
  return getActivtyThreadInstances.get();
}

export function saveMigration(activityId, data) {
  return createActivityMigration.save({ activityId }, data);
}

export function videoActivityUploadFactV1(activityId, queryParams) {
  return videoUploadResourceV1.update({ activityId }, { ...queryParams });
}

export function imageActivityUploadFactV2(activityId, data, isInstructionTemplate) {
  if (isInstructionTemplate) {
    return templateImageUploadResourceV2.save({ activityId }, data);
  }
  return imageUploadResourceV2.save({ activityId }, data);
}

export function getUploadedVideoConvertedURL(pathParams, queryParams) {
  return uploadLocalVideoResource.get({ ...pathParams, ...queryParams });
}

export function covertUploadedLocalVideo(pathParams, queryParams) {
  return convertVideoResource.update({ ...pathParams }, { ...queryParams });
}
